import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const setFormValues = hooks.useFormChange()
  const { PACKAGE_ENABLED, TAXI_ENABLED, B2B_ENABLED } = hooks.useRelayFeatures(['PACKAGE_ENABLED', 'TAXI_ENABLED', 'B2B_ENABLED'])
  const { CODE_INTERNATIONAL } = hooks.useRelayConstants(['CODE_INTERNATIONAL'])
  const [{ isB2B, isManagingRecord, isOrderDuplicate, user_id }, setFormState] = hooks.useFormState()
  const [
    application_id,
    payment_type,
    loads,
    userFields
  ] = hooks.useFieldValues(['user.application', 'payment_type', 'loads', 'user'])

  const user_populate = ['user_companies.companyuser_services.companyservice.contract', 'user_companies.companyuser_services.companyuser', 'auth', 'info', 'customerinfo']
  const [user] = hooks.useModel('user', [user_id], { populate: user_populate, single: true })
  const [users, searchUser, , { clear: clearUsers }] = hooks.useModelSearch('user', 'get', { populate: user_populate, search_id: 'customer_search' })
  const [applications] = hooks.useModelSearch('application', 'get', { initial_filter: {} })

  const normalizePhone = useCallback(Callbacks.normalizePhoneHandler(CODE_INTERNATIONAL), [CODE_INTERNATIONAL])
  const onTypeChange = useCallback(Callbacks.onTypeChangeHandler(setFormState, setFormValues, loads, userFields, isB2B), [setFormState, setFormValues, loads, userFields, isB2B])
  const onLoadTypeChange = useCallback(Callbacks.onLoadTypeChangeHandler(user, setFormValues, payment_type), [user, setFormValues, payment_type])
  const onApplicationChange = useCallback(Callbacks.onApplicationChangeHandler(setFormValues, applications, users, user_id), [setFormValues, applications, users, user_id])
  const onFieldClear = useCallback(Callbacks.onFieldClearHandler(clearUsers, setFormState), [clearUsers, setFormState])
  const searchGSM = useCallback(Callbacks.searchGSMHandler(searchUser, application_id), [searchUser, application_id])

  const application_ids = _.map(applications, 'application_id')
  const disabled = !!isManagingRecord || !!isOrderDuplicate

  const mergedProps = {
    disabled,
    B2B_ENABLED,
    PACKAGE_ENABLED,
    TAXI_ENABLED,
    application_ids,
    isB2B,
    isManagingRecord,
    searchUser,
    normalizePhone,
    onTypeChange,
    onLoadTypeChange,
    onApplicationChange,
    onFieldClear,
    searchGSM
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
